export default __webpack_public_path__ + "static/media/banner1.edc1cb1e.png";